import { useState } from 'react';

import { Stack, TextField, Button as MuiButton } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import BottomSheet from '@/designs-dev/device/BottomSheet';
import { type DocItem } from '@/north-star/care/fixtures';

// Kebab actions for a document: view / edit / delete, stacked in a hug-height
// drawer with the standard X to dismiss. Edit closes this sheet and opens the
// edit drawer.
export const DocActionsSheet = ({
  onView,
  onEdit,
  onDelete,
  onClose,
}: {
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onClose: () => void;
}) => (
  <BottomSheet variant='hug' onClose={onClose}>
    <Stack sx={{ pb: 1 }} spacing={1.5}>
      <MuiButton
        fullWidth
        size='large'
        variant='outlined'
        color='primary'
        onClick={onView}
      >
        View in browser
      </MuiButton>
      <MuiButton
        fullWidth
        size='large'
        variant='outlined'
        color='primary'
        onClick={onEdit}
      >
        Edit
      </MuiButton>
      <MuiButton
        fullWidth
        size='large'
        variant='outlined'
        sx={{ color: 'error.main', borderColor: 'error.main' }}
        onClick={onDelete}
      >
        Delete
      </MuiButton>
    </Stack>
  </BottomSheet>
);

// The edit drawer: rename the document, save changes.
export const EditDocSheet = ({
  doc,
  onSave,
  onClose,
}: {
  doc: DocItem;
  onSave: (name: string) => void;
  onClose: () => void;
}) => {
  const [name, setName] = useState(doc.name);

  return (
    <BottomSheet
      variant='full'
      title='Edit document'
      onClose={onClose}
      footer={
        <Button
          variant='primary'
          size='lg'
          isFullWidth
          ariaLabel='Save changes'
          onPress={() => onSave(name)}
        >
          Save changes
        </Button>
      }
    >
      <TextField
        fullWidth
        label='Title'
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
    </BottomSheet>
  );
};
